import React, { MouseEvent } from 'react';

import { BaseButton, type ButtonColor, type ButtonSize } from './BaseButton';

export interface ButtonProps {
  onTrigger?: (evt: MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  /** `primary` | `secondary` | `ghost` | `danger` (legacy names are accepted as aliases). */
  color?: ButtonColor;
  /** 10 = default (36px), 8 = compact (28px), 6 = inline (24px). */
  size?: ButtonSize;
  children?: React.ReactNode;
  isDisabled?: boolean;
  isLoading?: boolean;
  /** Tailwind width class, e.g. `w-full`. */
  width?: string;
  iconLeft?: React.ReactElement;
  iconRight?: React.ReactElement;
  ariaLabel?: string;
  title?: string;
}
export type Ref = HTMLButtonElement;

export const Button = React.forwardRef<Ref, ButtonProps>((props, ref) => {
  const {
    onTrigger,
    type = 'button',
    color = 'secondary',
    size,
    children,
    isDisabled,
    isLoading,
    width = 'w-auto',
    iconLeft,
    iconRight,
    ariaLabel,
    title,
  } = props;

  return (
    <BaseButton
      isLoading={isLoading}
      onClick={onTrigger}
      type={type}
      color={color}
      size={size}
      disabled={isDisabled}
      className={width}
      aria-label={ariaLabel}
      title={title}
      iconLeft={iconLeft}
      iconRight={iconRight}
      ref={ref}
    >
      {children}
    </BaseButton>
  );
});
